export const stripHTML = (value = "") => {
  return value.replace(/(<([^>]+)>)/gi, "").replace(/&nbsp;/gi, " ").trim()
}
